import React from "react";
import { ContentBoxItem } from "../ContentBoxItem/ContentBoxItem";
import { Item } from "@common/utils/helpers/buildDocItem";

interface IContentBoxProps {
  label: string;
  content: Item[],
  isBoxLoanDocuments?: boolean,
  isBoxAdditionalDocuments?: boolean
}

export const ContentBox: React.FC<IContentBoxProps> = ({
  label,
  content,
  isBoxLoanDocuments = false,
  isBoxAdditionalDocuments = false
}) => {

  if (!content?.length) return null;

  const loanDocsClosing = [
    'Pre-approval letter',
    'Closing documents',
    'Term sheet',
    'Appraisal'
  ];
  const optionalContentInAdditionalDocuments = [
    'Construction Budget',
    'Purchase contract',
    'Payoff letter',
  ];

  const additionalDocumentsTypes = [
    'Construction Budget',
    'Purchase contract',
    'Payoff letter',
    'Insurance',
    'Title'
  ];

  const isAdditionalDocument = (fieldName: string) => {
    if (additionalDocumentsTypes.includes(fieldName)) {
      return true;
    }

    if (!loanDocsClosing.includes(fieldName)) {
      return true;
    }

    return false;
  };
  // Helpers para filtrar por tipo
  const filterByField = (name: string) => content.filter(item => item.field === name);
  const filterIn = (names: string[]) => content.filter(item => names.includes(item.field));
  const filterNotIn = (names: string[]) => content.filter(item => !names.includes(item.field));

  const termSheetContent = filterByField("Term sheet");
  const preApprovalContent = filterByField("Pre-approval letter");
  const insuranceContent = filterByField("Insurance");
  const titleContent = filterByField("Title");
  const appraisalContent = filterByField("Appraisal");
  const otherContent = filterNotIn(loanDocsClosing);
  const optionalContent = filterIn(optionalContentInAdditionalDocuments);

  //Filtrar los loanDocs que fueron creados (no tienen key)
  const loanDocumentsCreated = content.filter(item => (item as any)?.loanDocCreated && !(item as any)?.loanDocCreated.hidden);  

  const additionalDocuments = content.filter(item =>
    isAdditionalDocument(item.field) &&
    !additionalDocumentsTypes.includes(item.field) &&
    !(item as any)?.loanDocCreated
  );

  const closingFiles = filterByField("Closing documents");

  const renderSection = (items: Item[], keyPrefix: string, showFieldOnlyFirst = true) => (
    items.length > 0 && (
      <div className="content" key={`${keyPrefix}-section`}>
        {items.map((item, index) => (
          <ContentBoxItem
            key={`${keyPrefix}-${index}`}
            item={item}
            index={index}
            showFieldOnlyFirst={showFieldOnlyFirst}
          />
        ))}
      </div>
    )
  );
  
  return (
    <div className='content-box'>
      <div className='label'>{label}</div>
      <br />
      {/* Secciones especiales para Loan Documents */}
      {isBoxLoanDocuments && (
        <>
          {renderSection(termSheetContent, "termSheet")}
          <br />
          {renderSection(preApprovalContent, "preApproval")}
          <br />
          {renderSection(appraisalContent, "appraisal")}
        </>
      )}
      {otherContent.length > 0 && !isBoxLoanDocuments && !isBoxAdditionalDocuments && (
        renderSection(otherContent, "other", false)
      )}
      {/* Additional Documents */}
      {isBoxAdditionalDocuments && (
        <>
          {renderSection(optionalContent, "optional", false)}
          <br />
          {renderSection(insuranceContent, "insurance")}
          <br />
          {renderSection(titleContent, "title")}
          <br />
          {additionalDocuments?.map((doc: any, index: number) => (
            <React.Fragment key={`additional-doc-${index}`}>
              {renderSection([doc], `additional_documents_${index}`, false)}
              {index < additionalDocuments.length - 1 && <br />}
            </React.Fragment>
          ))}
          <br />
          {loanDocumentsCreated?.map((loanDoc: any, index: number) => (
            <React.Fragment key={`loan-doc-${index}`}>
              {renderSection([loanDoc], `loan_docs_created_${index}`, false)}
              {index < loanDocumentsCreated.length - 1 && <br />}
            </React.Fragment>
          ))}
        </>
      )}
      <br />
      {renderSection(closingFiles, "closingFiles")}
    </div>
  );
};